module.exports = __webpack_public_path__ + "static/media/at-the-heart-of-the-consumer-s-news-fast-fashion.1bfe96a2.jpg";